import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, Spinner } from "react-bootstrap";
import axios from "axios";
import { config } from "../CommonUtils/CommonURLS";
import md5 from "md5";
import { jwtDecode } from "jwt-decode";
// import Cookies from "js-cookie";
import { CommonAxiosGet } from "../CommonUtils/CommonAxios";
import { getTokenExpiry } from "../CommonUtils/TimeUtility";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";
import { MdEmail, MdPhone } from "react-icons/md";
import {
  FaBell,
  FaBullhorn,
  FaQuestionCircle,
  FaFileAlt,
  FaCheckCircle,
  FaMapMarkerAlt,
  FaHeadset,
  FaBook,
  FaVideo,
  FaDownload,
  FaExternalLinkAlt,
  FaChevronRight,
  FaArrowRight,
  FaClock,
  FaCalendarAlt,
  FaGraduationCap,
  FaUniversity,
  FaBriefcase,
  FaIdCard,
  FaUpload,
  FaCertificate,
} from "react-icons/fa";
import * as affl from "react-bootstrap";
import { CommonFooter } from "../CommonUtils/CommonHeaderFooter";
import { clearAuthSession } from "../RequireAuth";

/* ── Constants ── */
const MODAL = { NONE: null, STUDENT: "student", COLLEGE: "college", DEPT: "dept" };

/* ── Styles ── */
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');

  .portal-root * { box-sizing: border-box; }
  .portal-root { font-family: 'Plus Jakarta Sans', sans-serif; }

  /* NAVBAR */
  .pnav {
    background: #fff;
    border-bottom: 1px solid #e2e8f0;
    padding: 0 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
    position: sticky;
    top: 0;
    z-index: 100;
    flex-wrap: wrap;
    gap: 8px;
  }
  .pnav-brand { display: flex; align-items: center; gap: 10px; }
  .pnav-logo {
    width: 44px; height: 44px; border-radius: 10px;
    overflow: hidden; display: flex; align-items: center;
    justify-content: center; background: #f1f5f9; flex-shrink: 0;
  }
  .pnav-logo img { width: 100%; height: 100%; object-fit: contain; }
  .pnav-title { font-size: 14px; font-weight: 600; color: #0f172a; line-height: 1.3; }
  .pnav-sub { font-size: 11px; color: #64748b; }
  .pnav-right { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }

  .deadline-chip {
    display: flex; align-items: center; gap: 5px;
    padding: 5px 11px; border-radius: 6px;
    background: #fef9c3; color: #854d0e;
    border: 1px solid #fde047; font-size: 11px; font-weight: 600;
  }

  .icon-btn {
    position: relative; background: none;
    border: 1px solid #e2e8f0; border-radius: 8px;
    width: 38px; height: 38px; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    color: #64748b; font-size: 16px; transition: background .15s;
  }
  .icon-btn:hover { background: #f1f5f9; }
  .icon-btn .bell-icon { color: #1d4ed8; }
  .notif-badge {
    position: absolute; top: -5px; right: -5px;
    width: 17px; height: 17px; border-radius: 50%;
    background: #dc2626; color: #fff;
    font-size: 9px; font-weight: 700;
    display: flex; align-items: center; justify-content: center;
    border: 2px solid #fff;
  }

  .nav-pill {
    display: flex; align-items: center; gap: 6px;
    padding: 7px 14px; border-radius: 8px; font-size: 12px; font-weight: 500;
    border: 1px solid #e2e8f0; background: none; cursor: pointer;
    color: #475569; transition: background .15s; font-family: inherit;
  }
  .nav-pill:hover { background: #f1f5f9; }
  .nav-icon {
    width: 20px;
    height: 20px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .nav-icon-book { background: #ede9fe; color: #6d28d9; }
  .nav-icon-help { background: #dbeafe; color: #1d4ed8; }
  .nav-icon-guide { background: #fee2e2; color: #b91c1c; }
  .nav-icon-bell { background: #f8dcfc; color: #fa3200e8; }

  /* ENVIRONMENT WARNING */
  .env-warning {
    background: linear-gradient(90deg, #7f1d1d 0%, #991b1b 100%);
    color: #fff;
    border-top: 1px solid #991b1b;
    border-bottom: 1px solid #991b1b;
    padding: 8px 14px;
    position: sticky;
    top: 64px;
    z-index: 95;
  }
  .env-warning-inner {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .env-warning-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
    min-width: 0;
    flex: 1;
  }
  .env-warning-title {
    margin: 0;
    color: #fff;
    font-size: 16px;
    font-weight: 800;
    letter-spacing: .01em;
    line-height: 1.25;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .env-warning-icon {
    width: 22px;
    height: 22px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.14);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    flex-shrink: 0;
  }
  .env-warning-text {
    margin: 0;
    color: #ffe8c2;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.35;
  }
  .env-warning-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 34px;
    padding: 7px 14px;
    border-radius: 8px;
    background: #fde047;
    color: #991b1b;
    font-size: 13px;
    font-weight: 700;
    text-decoration: none;
    white-space: nowrap;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
    transition: transform .15s ease, box-shadow .15s ease, background .15s ease;
  }
  .env-warning-link:hover {
    background: #facc15;
    color: #7f1d1d;
    transform: translateY(-1px);
    box-shadow: 0 5px 12px rgba(0, 0, 0, 0.22);
  }
  .env-warning-link:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 2px;
  }

  /* LATEST NEWS */
  .latest-news-shell {
    display: flex;
    align-items: center;
    width: 100%;
    height: 42px;
    overflow: hidden;
    border: 1px solid #c7d8ea;
    border-radius: 8px;
    background: #ffffff;
  }
  .latest-news-label {
    background: #e08411;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .02em;
    text-transform: uppercase;
    padding: 0 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    flex-shrink: 0;
    height: 100%;
    min-width: 170px;
    border-radius: 0;
    box-shadow: none;
    border-right: 1px solid rgba(255, 255, 255, 0.28);
  }
  .latest-news-track {
    position: relative;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    color: #475569;
    font-size: 13px;
    font-weight: 500;
    background: transparent;
    border-radius: 0;
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 12px;
  }
  .latest-news-move {
    display: inline-block;
    padding-left: 100%;
    animation: latest-news-scroll 36s linear infinite;
  }
  .latest-news-shell:hover .latest-news-move,
  .latest-news-shell:focus-within .latest-news-move {
    animation-play-state: paused;
  }
  .latest-news-item {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    margin-right: 64px;
  }
  .latest-news-sep {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #f59e0b;
  }
  @keyframes latest-news-scroll {
    0% { transform: translateX(0%); }
    100% { transform: translateX(-100%); }
  }
 
  .drop-menu {
    position: absolute; top: 46px; right: 0;
    background: #f1fcff; border: 1px solid #f0efe2;
    border-radius: 14px; box-shadow: 0 8px 30px rgba(0,0,0,0.12);
    overflow: hidden; z-index: 300; min-width: 270px;
  }
  .drop-hdr {
    padding: 12px 16px; border-bottom: 1px solid #f1f5f9;
    display: flex; justify-content: space-between; align-items: center;
  }
  .drop-hdr span { font-size: 13px; font-weight: 600; color: #0f172a; }
  .drop-clear { font-size: 11px; color: #2563eb; background: none; border: none; cursor: pointer; font-family: inherit; }
  .notif-item {
    padding: 11px 16px; border-bottom: 1px solid #f8fafc;
    display: flex; gap: 10px; align-items: flex-start;
    transition: background .1s; cursor: default;
  }
  .notif-item:last-child { border-bottom: none; }
  .notif-item:hover { background: #f8fafc; }
  .notif-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; margin-top: 5px; }
  .notif-text { font-size: 12px; color: #334155; line-height: 1.5; }
  .notif-time { font-size: 10px; color: #94a3b8; margin-top: 2px; }
  .notif-download-icon { color: #0ea5e9; }
  .notif-popup-modal .modal-content {
    border: 0;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 48px rgba(15, 23, 42, 0.22);
  }
  .notif-popup-modal .modal-header {
    border-bottom: 0;
    background: linear-gradient(135deg, #0f4c75 0%, #0d9488 100%);
    padding: 16px 20px;
  }
  .notif-popup-modal .modal-title {
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .notif-popup-modal .btn-close {
    filter: invert(1) grayscale(100%) brightness(200%);
  }
  .notif-popup-modal .modal-body {
    background: #f8fbff;
    padding: 20px;
  }
  .notif-popup-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .notif-popup-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px;
    background: #fff;
    border: 1px solid #dbeafe;
    border-radius: 12px;
  }
  .notif-popup-item .notif-dot {
    margin-top: 6px;
  }
  .notif-popup-actions {
    margin-left: auto;
    flex-shrink: 0;
  }
  .notif-popup-download {
    width: 32px;
    height: 32px;
    border: 0;
    border-radius: 8px;
    background: #eff6ff;
    color: #2563eb;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .notif-popup-download:hover {
    background: #dbeafe;
  }
  .help-item {
    padding: 10px 16px; display: flex; align-items: center; gap: 10px;
    font-size: 13px; cursor: pointer; border-bottom: 1px solid #f8fafc;
    color: #334155; transition: background .1s;
  }
  .help-item:last-child { border-bottom: none; }
  .help-item:hover { background: #f8fafc; }
  .help-icon { width: 28px; height: 28px; border-radius: 7px; display: flex; align-items: center; justify-content: center; font-size: 13px; flex-shrink: 0; }

  /* HERO */
  .hero {
    background: #0f4c75;
    padding: 56px 48px;
    display: flex; align-items: center; gap: 52px; flex-wrap: wrap;
  }
  .hero-left { flex: 1; min-width: 300px; }
  .live-badge {
    display: inline-flex; align-items: center; gap: 7px;
    background: rgba(255,255,255,0.1); color: #bae6fd;
    font-size: 11px; font-weight: 600; padding: 5px 14px;
    border-radius: 20px; border: 1px solid rgba(186,230,253,0.25);
    margin-bottom: 20px; letter-spacing: .02em;
  }
  .live-dot { width: 7px; height: 7px; border-radius: 50%; background: #4ade80; }
  .hero h1 { font-size: 46px; font-weight: 700; color: #fff; line-height: 1.1; margin-bottom: 14px; }
  .hero h1 span { color: #5eead4; }
  .hero-p { color: #bae6fd; font-size: 14px; line-height: 1.85; max-width: 450px; margin-bottom: 30px; }
  .hero-btns { display: flex; gap: 10px; flex-wrap: wrap; margin-bottom: 36px; }
  .btn-teal {
    padding: 11px 24px; border-radius: 10px; border: none;
    background: #0d9488; color: #fff; font-size: 13px; font-weight: 600;
    cursor: pointer; display: flex; align-items: center; gap: 8px;
    transition: background .15s; font-family: inherit;
  }
  .btn-teal:hover { background: #0f766e; }
  .btn-ghost {
    padding: 11px 24px; border-radius: 10px;
    background: rgba(255,255,255,0.08); color: #e2e8f0;
    border: 1px solid rgba(255,255,255,0.18); font-size: 13px; font-weight: 600;
    cursor: pointer; display: flex; align-items: center; gap: 8px;
    transition: background .15s; font-family: inherit;
  }
  .btn-ghost:hover { background: rgba(255,255,255,0.15); }
  .hero-btn-icon {
    width: 18px;
    height: 18px;
    border-radius: 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(186, 230, 253, 0.22);
    color: #67e8f9;
  }
  .stats-row { display: flex; gap: 12px; flex-wrap: wrap; }
  .stat-box {
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.13);
    border-radius: 12px; padding: 14px 20px; min-width: 108px;
  }
  .stat-v { font-size: 22px; font-weight: 700; color: #fff; }
  .stat-l { font-size: 11px; color: #7dd3fc; margin-top: 2px; }

  /* LOGIN PANEL */
  .login-panel {
    background: #fffbeb;
    border: 1px solid #fde68a;
    border-radius: 20px; padding: 26px;
    flex: 1; min-width: 300px; max-width: 680px;
  }
  .lp-hdr { display: flex; align-items: center; gap: 8px; margin-bottom: 4px; }
  .lp-hdr-icon { width: 32px; height: 32px; border-radius: 8px; background: #fef3c7; display: flex; align-items: center; justify-content: center; color: #92400e; font-size: 15px; }
  .lp-title { font-size: 16px; font-weight: 700; color: #78350f; }
  .lp-sub { font-size: 11px; color: #a16207; margin-bottom: 18px; padding-left: 40px; }
  .lcard {
    display: flex; align-items: center; gap: 12px;
    padding: 13px 14px; border-radius: 12px;
    border: 1px solid #fde68a; background: #fff;
    cursor: pointer; margin-bottom: 10px;
    transition: border-color .15s, background .15s, transform .1s;
  }
  .lcard:last-child { margin-bottom: 0; }
  .lcard:hover { border-color: #f59e0b; background: #fffde7; transform: translateX(2px); }
  .lcard-icon { width: 42px; height: 42px; border-radius: 11px; display: flex; align-items: center; justify-content: center; font-size: 20px; flex-shrink: 0; }
  .lcard-title { font-size: 13px; font-weight: 600; color: #1e293b; }
  .lcard-sub { font-size: 11px; color: #64748b; margin-top: 1px; }
  .lcard-arrow { margin-left: auto; color: #d97706; font-size: 13px; }

  /* SCHEDULE */
  .sched-section { background: #eaf6ff; padding: 0; border-bottom: 1px solid #bae6fd; }
  .sched-bar { display: block; }
  .sched-news-inline {
    display: flex;
    align-items: center;
    width: 100%;
  }
  .sched-lbl { font-size: 12px; font-weight: 600; color: #0369a1; display: flex; align-items: center; gap: 5px; }
  .chip { padding: 5px 12px; border-radius: 6px; font-size: 11px; font-weight: 600; display: flex; align-items: center; gap: 5px; }
  .chip-g { background: #dcfce7; color: #166534; border: 1px solid #86efac; }
  .chip-r { background: #fee2e2; color: #991b1b; border: 1px solid #fca5a5; }
  .chip-b { background: #dbeafe; color: #1e40af; border: 1px solid #93c5fd; }
  .chip-a { background: #fef9c3; color: #854d0e; border: 1px solid #fde047; }

  /* INFO */
  .info-section { background: #f8fafc; padding: 40px 48px 48px; }
  .sec-eye { font-size: 11px; font-weight: 700; color: #0d9488; text-transform: uppercase; letter-spacing: .08em; margin-bottom: 5px; }
  .sec-title { font-size: 22px; font-weight: 700; color: #0f172a; margin-bottom: 22px; }
  .info-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 16px; }
  .icard { background: #fff; border: 1px solid #e2e8f0; border-radius: 16px; padding: 22px; transition: border-color .15s; }
  .icard:hover { border-color: #94a3b8; }
  .icard-icon { width: 42px; height: 42px; border-radius: 11px; display: flex; align-items: center; justify-content: center; font-size: 18px; margin-bottom: 14px; }
  .icard-title { font-size: 14px; font-weight: 600; color: #0f172a; margin-bottom: 6px; }
  .icard-desc { font-size: 12px; color: #64748b; line-height: 1.75; }

  /* PROCESS */
  .proc-section { background: #fff; padding: 36px 48px 44px; border-top: 1px solid #e2e8f0; }
  .steps { display: flex; gap: 0; overflow-x: auto; padding-bottom: 4px; }
  .step { flex: 1; min-width: 110px; display: flex; flex-direction: column; align-items: center; text-align: center; position: relative; padding: 0 6px; }
  .step-num { width: 36px; height: 36px; border-radius: 50%; background: #0f4c75; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 700; position: relative; z-index: 2; }
  .step-line { position: absolute; top: 18px; left: calc(50% + 18px); right: calc(-50% + 18px); height: 1px; background: #cbd5e1; z-index: 1; }
  .step-t { font-size: 12px; font-weight: 600; color: #0f172a; margin-top: 10px; }
  .step-d { font-size: 11px; color: #64748b; margin-top: 3px; line-height: 1.5; }

  /* CONTACT */
  .contact-section { background: #f0f9ff; padding: 32px 48px; display: flex; gap: 32px; flex-wrap: wrap; border-top: 1px solid #bae6fd; }
  .cblock { flex: 1; min-width: 200px; }
  .cblock h4 { font-size: 13px; font-weight: 700; color: #0369a1; margin-bottom: 10px; display: flex; align-items: center; gap: 7px; }
  .cblock p { font-size: 12px; color: #334155; line-height: 1.9; }
  .clink { color: #0d9488; font-size: 12px; display: flex; align-items: center; gap: 5px; margin-top: 7px; cursor: pointer; font-weight: 500; }

  /* MAP */
  .map-section { background: #fff; padding: 0 48px 44px; }
  .map-wrap {
    border-radius: 16px;
    overflow: hidden;
    border: 1px solid #e2e8f0;
    margin-top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .map-hdr { padding: 14px 20px; border-bottom: 1px solid #f1f5f9; display: flex; align-items: center; gap: 8px; background: #f8fafc; }
  .map-hdr-icon { width: 30px; height: 30px; border-radius: 8px; background: #e0f2fe; display: flex; align-items: center; justify-content: center; color: #0369a1; font-size: 14px; }
  .map-hdr span { font-size: 13px; font-weight: 600; color: #0f172a; }
  .map-hdr small { font-size: 11px; color: #64748b; margin-left: auto; }
  .map-wrap iframe { flex: 1; min-height: 340px; }

  /* ABOUT SECTION */
  .about-section { background: #fff; padding: 0 48px 0; }
  .about-row { align-items: stretch; }
  .about-col, .map-col { display: flex; }
  .about-card {
    background: #f8fafc; border: 1px solid #e2e8f0;
    border-radius: 16px; padding: 28px; height: 100%; width: 100%;
  }
  .about-card h4 { font-size: 16px; font-weight: 700; color: #0f172a; margin-bottom: 16px; }
  .about-card h5 { font-size: 12px; font-weight: 700; color: #0369a1; margin-bottom: 8px; text-transform: uppercase; letter-spacing: .05em; }
  .about-card p { font-size: 13px; color: #334155; line-height: 1.85; }

  @media (max-width: 767px) {
    .env-warning {
      padding: 10px 12px;
    }
    .env-warning-inner {
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
    }
    .env-warning-content {
      align-items: center;
      text-align: center;
    }
    .env-warning-title {
      justify-content: center;
      font-size: 14px;
    }
    .env-warning-text { font-size: 12px; }
    .env-warning-link {
      width: 100%;
      max-width: 260px;
      margin: 0 auto;
      font-size: 12px;
      padding: 8px 12px;
    }
    .about-col, .map-col { display: block; }
    .map-wrap iframe { min-height: 280px; }
    .latest-news-label {
      font-size: 11px;
      padding: 0 10px;
      min-width: 138px;
    }
    .latest-news-track {
      font-size: 11px;
      padding-left: 10px;
    }
    .latest-news-item {
      margin-right: 42px;
    }
    .sched-news-inline { width: 100%; }
    .sched-section { padding: 0; }
  }

  /* FOOTER */
  .pfooter { background: #0f4c75; padding: 16px 48px; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 8px; }
  .pfooter p { font-size: 11px; color: #7dd3fc; }

  /* LOGIN FORM */
  .lf-input {
    width: 100%; height: 48px; border-radius: 12px;
    border: 1px solid #dbeafe; padding: 0 14px;
    font-size: 14px; outline: none; background: #fff;
    font-family: inherit; transition: border-color .2s;
  }
  .lf-input:focus { border-color: #1b6ca8; }
  .lf-label { font-size: 13px; color: #475569; margin-bottom: 7px; display: block; font-weight: 600; }
  .lf-group { margin-bottom: 18px; }
  .lf-submit {
    width: 100%; height: 50px; border-radius: 14px; border: none;
    font-weight: 700; font-size: 16px; cursor: pointer;
    font-family: inherit; transition: opacity .15s;
  }
  .lf-submit:hover { opacity: 0.88; }
  .lf-error {
    background: #fef2f2; color: #dc2626;
    padding: 10px; border-radius: 10px;
    margin-bottom: 16px; text-align: center;
    font-size: 13px; border: 1px solid #fecaca;
  }
  .lf-register-bar {
    display: flex; justify-content: space-between; align-items: center;
    margin-bottom: 22px; padding: 12px 14px;
    background: #f8fafc; border-radius: 12px; border: 1px solid #e2e8f0;
  }
  .lf-register-label { font-size: 14px; font-weight: 600; color: #15803d; }
  .lf-register-btn {
    border: 1px solid #0ea5e9; background: #fff; color: #0ea5e9;
    padding: 9px 18px; border-radius: 10px; font-weight: 600;
    cursor: pointer; display: flex; align-items: center; gap: 7px;
    font-family: inherit; font-size: 13px;
  }
  .captcha-row { display: flex; gap: 10px; align-items: center; margin-bottom: 10px; }
  .captcha-box {
    min-width: 120px; height: 48px; border-radius: 10px;
    overflow: hidden; border: 1px solid #dbeafe;
    display: flex; align-items: center; justify-content: center; background: #fff;
  }
  .captcha-refresh {
    width: 48px; height: 48px; border-radius: 10px; border: none;
    background: #eff6ff; cursor: pointer; font-size: 20px; flex-shrink: 0;
  }
`;

/* ────── LOGIN FORM ────── */
function LoginForm({ roleKey, accentColor, textColor = "#fff", uidLabel, uidPlaceholder, onSuccess }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaId, setCaptchaId] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const GetCaptcha = () => {
    axios.get(config.url.STU_URL + "captcha").then((res) => {
      if (res?.data?.scode === "01") {
        setCaptcha(res?.data?.sdesc);
        setCaptchaId(res?.data?.captchaId);
      } else {
        setCaptcha("");
        setCaptchaId("");
      }
    });
  };

  useEffect(() => { GetCaptcha(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!userId.trim() || !password.trim() || !captchaInput.trim()) {
      setError("Please fill all fields");
      return;
    }
    setLoading(true);
    try {
      const loginType = roleKey === "student" ? "student" : roleKey === "college" ? "college" : "university";
      sessionStorage.setItem("loginType", loginType);
      const body = {
        userId: userId.trim(),
        userPassword: md5(password.trim()),
        captcha: captchaInput,
        captchaId,
        loginType,
        acYear: "2026-27",
      };
      const response = await axios.post(config.url.STU_URL + "auth/authenticate", body);
      if (response?.data?.responseCode === "01") {
        const decodedToken = jwtDecode(response.data.accessToken);
        const tokenExpiry = getTokenExpiry(response.data.accessToken);
        const refreshExpiry = getTokenExpiry(response.data.refreshToken);
        // Cookies.set("token", response.data.accessToken);
        // Cookies.set("refreshToken", response.data.refreshToken);
        // Cookies.set("tokenTime", tokenExpiry);
        // Cookies.set("refreshTokenTime", refreshExpiry);
        console.log("Decoded Token:", decodedToken);
        sessionStorage.setItem("token", response.data.accessToken);
        sessionStorage.setItem("refreshToken", response.data.refreshToken);
        sessionStorage.setItem("tokenTime", tokenExpiry);
        sessionStorage.setItem("refreshTokenTime", refreshExpiry);

        sessionStorage.setItem("decodedToken", JSON.stringify(decodedToken));
        sessionStorage.setItem("user_id", decodedToken?.user_id);
        sessionStorage.setItem("user_name", decodedToken?.empl_first_name);
        sessionStorage.setItem("autonomous", decodedToken?.autonomous);
        CommonAxiosGet(config.url.STU_URL + "getServices").then((res) => {
          if (res?.data?.scode === "01") {
            sessionStorage.setItem("menuData", JSON.stringify(res.data.services));
            navigate("/RusaDashboard");
          }
        });
        onSuccess();
      } else {
        setError(response?.data?.sdesc || "Invalid Credentials");
        setCaptchaInput("");
        GetCaptcha();
      }
    } catch (err) {
      console.log(err);
      setError("Server Error");
      GetCaptcha();
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {roleKey === "student" && (
        <div className="lf-register-bar">
          <span className="lf-register-label">New user?</span>
          <button type="button" className="lf-register-btn" onClick={() => navigate("/RegistrationForm")}>
            🪪 Register Here
          </button>
        </div>
      )}

      <div className="lf-group">
        <label className="lf-label">{uidLabel}</label>
        <input className="lf-input" type="text" placeholder={uidPlaceholder} value={userId} onChange={(e) => setUserId(e.target.value)} />
      </div>

      <div className="lf-group">
        <label className="lf-label">Password</label>
        <div style={{ position: "relative" }}>
          <input
            className="lf-input"
            type={showPassword ? "text" : "password"}
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ paddingRight: "46px" }}
          />
          <span
            onClick={() => setShowPassword(!showPassword)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                setShowPassword(!showPassword);
              }
            }}
            role="button"
            tabIndex={0}
            style={{ position: "absolute", right: "14px", top: "13px", cursor: "pointer", color: "#6366f1" }}>
            {showPassword ? <IoIosEye size={22} /> : <IoIosEyeOff size={22} />}
          </span>
        </div>
      </div>

      <div className="lf-group">
        <label className="lf-label">Captcha</label>
        <div className="captcha-row">
          <div className="captcha-box">
            {captcha && <img src={captcha} alt="captcha" style={{ width: "100%", height: "100%", objectFit: "contain" }} />}
          </div>
          <button type="button" className="captcha-refresh" onClick={GetCaptcha}>↻</button>
          <input
            className="lf-input"
            type="text"
            placeholder="Enter captcha"
            maxLength={5}
            value={captchaInput}
            onChange={(e) => setCaptchaInput(e.target.value)}
            style={{ flex: 1, minWidth: 0 }}
          />
        </div>
      </div>

      {error && <div className="lf-error">{error}</div>}

      <button
        className="lf-submit"
        type="submit"
        disabled={loading}
        style={{ background: accentColor, color: textColor }}
      >
        {loading ? <Spinner animation="border" size="sm" /> : "Sign In"}
      </button>
    </form>
  );
}

/* ────── MAIN COMPONENT ────── */
export default function Home1() {
  const navigate = useNavigate();
  const [activeModal, setActiveModal] = useState(MODAL.NONE);
  const [showNotif, setShowNotif] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const appEnv = (config?.url?.APP_ENV || "").toLowerCase();
  const showDevWarning = appEnv === "dev" || appEnv === "local";
  const officialWebsiteUrl = config?.url?.OFFICIAL_WEBSITE_URL || "https://studentmigration.apcfss.in";
  const USER_MANUAL_FILE = "Student_Migration_UserManual_Draft.pdf";
  // const GUIDELINES_FILE = "Students Transfers 2026-27-Approved Copy-18-07-2026-1.pdf";
  const GUIDELINES_FILE = "guildelineslatest.pdf";
  const notifications = [
    { dot: "#2563eb", text: "Applications for the 2026-27 Student Migration are open from 27 July 2026.", fileName: GUIDELINES_FILE },
    { dot: "#16a34a", text: "Student Migration User Manual is available for download.", fileName: USER_MANUAL_FILE },
  ];

  const latestNews = [
    "Student Migration applications for the academic year 2026-27 are open from 27 July 2026.",
  ];

  const getPdfPath = (fileName) => `/${encodeURIComponent(fileName)}`;

  const openModal = (type) => setActiveModal(type);
  const closeModal = () => setActiveModal(MODAL.NONE);
  const openPdf = (fileName) => window.open(getPdfPath(fileName), "_blank", "noopener,noreferrer");
  const downloadPdf = (fileName) => {
    const link = document.createElement("a");
    link.href = getPdfPath(fileName);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const toggleNotif = (e) => { e.stopPropagation(); setShowNotif((p) => !p); setShowHelp(false); };
  const toggleHelp = (e) => { e.stopPropagation(); setShowHelp((p) => !p); setShowNotif(false); };

  useEffect(() => {
    const close = () => { setShowNotif(false); setShowHelp(false); };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);

  const infoCards = [
    { icon: <FaFileAlt />, bg: "#ede9fe", color: "#6d28d9", title: "How to apply", desc: "Log in as a student, complete the migration form, and upload required documents before the closing date." },
    { icon: <FaCheckCircle />, bg: "#dcfce7", color: "#15803d", title: "Eligibility criteria", desc: "Completed at least one semester at your current institution with no active academic backlogs." },
    { icon: <FaMapMarkerAlt />, bg: "#dbeafe", color: "#1d4ed8", title: "18 universities covered", desc: "Transfers available across all 19 state universities including autonomous and affiliated colleges in AP." },
    { icon: <FaUpload />, bg: "#fef9c3", color: "#92400e", title: "Documents required", desc: "Aadhaar, previous mark sheets, bonafide certificate, and migration request letter from current institution." },
    { icon: <FaHeadset />, bg: "#fee2e2", color: "#b91c1c", title: "Need help?", desc: "Use the Help menu in the navbar for guides, FAQs, video tutorials, and helpdesk contact details." },
    { icon: <FaCertificate />, bg: "#f0fdf4", color: "#166534", title: "After approval", desc: "Download your migration certificate directly from the portal and submit it to your new institution." },
  ];

  const steps = [
    { n: 1, t: "Register", d: "Create student account" },
    { n: 2, t: "Fill form", d: "Pick source & destination" },
    { n: 3, t: "Upload docs", d: "Attach all certificates" },
    { n: 4, t: "Payment", d: "Make payment" },

    { n: 5, t: "College verify", d: "Current college approves" },
    { n: 6, t: "Dept review", d: "Department clearance" },
    { n: 7, t: "Download", d: "Get migration certificate" },
  ];

  useEffect(() => {
    clearAuthSession();
  }, [])
  return (
    <>
      <style>{styles}</style>
      <div className="portal-root">

        {/* ── NAVBAR ── */}
        <nav className="pnav">
          <div className="pnav-brand">
            <div className="pnav-logo">
              <img src="../images/chelogo.png" alt="CHE Logo" onError={(e) => { e.target.style.display = "none"; }} />
            </div>
            <div>
              <div className="pnav-title">Commissionerate of Higher Education</div>
              <div className="pnav-sub">Government of Andhra Pradesh</div>
            </div>
          </div>

          <div className="pnav-right">
            <button
              type="button"
              className="nav-pill"
              onClick={() => openPdf(USER_MANUAL_FILE)}
              title="Open Student Migration User Manual"
            >
              <span className="nav-icon nav-icon-book"><FaBook style={{ fontSize: 11 }} /></span> User Manual
            </button>

            {/* Notifications */}
            <div style={{ position: "relative" }} onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
              role="presentation">


              {/* <button className="icon-btn" onClick={toggleNotif} aria-label="Notifications">
                <FaBell className="bell-icon" /> Notifications
                <span className="notif-badge">3</span>
              </button> */}
              <button
                type="button"
                className="nav-pill"
                onClick={toggleNotif} aria-label="Notifications"
                title="View Notifications"
              >
                <span className="nav-icon nav-icon-bell bell-icon"><FaBell style={{ fontSize: 15 }} /></span> Notifications
                <img src="../images/new-icon.gif" alt="New"
                  style={{ height: "25px", width: "25px", objectFit: "contain" }} />
              </button>
            </div>

            <button className="nav-pill" onClick={() => openPdf(GUIDELINES_FILE)}>
              <span className="nav-icon nav-icon-guide"><FaFileAlt style={{ fontSize: 12 }} /></span> Guidelines
            </button>

            {/* Help */}
            <div style={{ position: "relative" }} onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
              role="presentation">
              <button className="nav-pill" onClick={toggleHelp}>
                <span className="nav-icon nav-icon-help"><FaQuestionCircle style={{ fontSize: 13 }} /></span> Help
              </button>
              {showHelp && (
                <div className="drop-menu" style={{ minWidth: 210 }}>
                  {[
                    { icon: <FaBook />, bg: "#ede9fe", color: "#6d28d9", label: "User guide", action: () => openPdf(USER_MANUAL_FILE) },
                    // { icon: <FaQuestionCircle />, bg: "#dbeafe", color: "#1d4ed8", label: "FAQs" },
                    // { icon: <FaVideo />, bg: "#dcfce7", color: "#15803d", label: "Video tutorials" },
                    { icon: <FaHeadset />, bg: "#fef3c7", color: "#92400e", label: "Contact helpdesk" },
                    // { icon: <FaDownload />, bg: "#fee2e2", color: "#b91c1c", label: "Download forms", action: () => downloadPdf(USER_MANUAL_FILE) },
                  ].map((h, i) => (
                    <div className="help-item" key={i}
                      onClick={() => { if (h.action) { h.action(); setShowHelp(false); } }}
                      onKeyDown={(e) => { if ((e.key === "Enter" || e.key === " ") && h.action) { h.action(); setShowHelp(false); } }} >
                      <span className="help-icon" style={{ background: h.bg, color: h.color }}>{h.icon}</span>
                      {h.label} {h.action && <FaExternalLinkAlt style={{ marginLeft: "auto", fontSize: 11, color: "#64748b" }} />}
                    </div>
                  ))}
                </div>
              )}
            </div>

          </div>
        </nav>

        {showDevWarning && (
          <div className="env-warning" role="alert" aria-live="assertive">
            <div className="env-warning-inner">
              <div className="env-warning-content">
                <h4 className="env-warning-title mb-2 mt-1">
                  <span className="env-warning-icon"><FaBullhorn /></span>
                  This website is for Development / Testing Environment
                </h4>

                <p className="env-warning-text mb-2 mt-1" style={{ fontSize: "15px" }}>
                  <strong>Testing purposes only</strong>.
                  Do not submit applications or enter official data on this site.
                </p>

                <a href={officialWebsiteUrl} target="_blank" rel="noopener noreferrer" className="env-warning-link" > Visit Official Website </a>
              </div>
            </div>
          </div>
        )}
        <section className="hero">
          <div className="hero-left">
            <div className="live-badge">
              <span className="live-dot" /> Applications open · Academic Year 2026–27
            </div>

            <h1> <span> Professional college's<br />
              Student Services Portal</span><br /></h1>
            <p className="hero-p">
              Apply for inter-college transfers, track approval status, and manage institution
              changes across all Andhra Pradesh universities — fast, paperless, and transparent.
            </p>
            {/* <div className="hero-btns">

              <button className="btn-ghost" onClick={() => openPdf(GUIDELINES_FILE)}>
                <span className="hero-btn-icon"><FaFileAlt /></span> View guidelines
              </button>
            </div> */}
            <div className="stats-row">
              {[
                { v: "18", l: "Universities" },

                { v: "350+", l: "Institutions" },
              ].map((s, i) => (
                <div className="stat-box" key={i}>
                  <div className="stat-v">{s.v}</div>
                  <div className="stat-l">{s.l}</div>
                </div>
              ))}
            </div>
          </div>

          {/* <div>
            <img
              src="../images/stumigration.png"
              alt="Student Migration"
              style={{
                width: "100%",
                maxWidth: "600px",
                height: "auto"
              }}
            />
          </div> */}
          <div className="login-panel">
            <div className="lp-hdr">
              <div className="lp-hdr-icon"><FaIdCard /></div>
              <div className="lp-title">Login access</div>
            </div>
            <div className="lp-sub">Select your role to sign in</div>

            {[
              { bg: "#fef3c7", icon: "🎓", title: "Student login", sub: "Apply & track your transfer", modal: MODAL.STUDENT },
              { bg: "#dcfce7", icon: "🏛️", title: "College login", sub: "Institution verification", modal: MODAL.COLLEGE },
              { bg: "#dbeafe", icon: "💼", title: "Department login", sub: "Administration access", modal: MODAL.DEPT },
            ].map((c, i) => (
              <div className="lcard" key={i} onClick={() => {
                // if (c.modal !== "college")
                openModal(c.modal);
              }}
                onKeyDown={(e) => {
                  // if ((e.key === "Enter" || e.key === " ") && c.modal !== "college")
                  openModal(c.modal);
                }}
                role="button" tabIndex={0}>
                <div className="lcard-icon" style={{ background: c.bg }}>{c.icon}</div>
                <div>
                  <div className="lcard-title">{c.title}</div>
                  <div className="lcard-sub">{c.sub}</div>
                </div>
                <FaChevronRight className="lcard-arrow" />
              </div>
            ))}
          </div>
        </section >

        {/* ── SCHEDULE BAR ── */}
        < section className="sched-section" >
          <div className="sched-bar">
            {/* <div className="sched-lbl"><FaCalendarAlt style={{ fontSize: 13 }} /> Application schedule 2026–27</div>
            <div className="chip chip-g"><FaCheckCircle style={{ fontSize: 10 }} /> Open: 27 July 2026</div>
            <div className="chip chip-r"><FaClock style={{ fontSize: 10 }} /> Close: 08 August 2026</div>
            <div className="chip chip-b"><FaUniversity style={{ fontSize: 10 }} /> College verify: by 12 August</div>
            <div className="chip chip-a"><FaCheckCircle style={{ fontSize: 10 }} /> Results: 20 Jun 2026</div> */}
            <div className="sched-news-inline" aria-label="Latest News">
              <div className="latest-news-shell">
                <div className="latest-news-label">
                  <FaBullhorn style={{ fontSize: 12 }} /> Latest Updates
                </div>
                <div className="latest-news-track">
                  <div className="latest-news-move">
                    {[...latestNews].map((item, index) => (
                      <span className="latest-news-item" key={index}>
                        <span className="latest-news-sep" />
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section >

        {/* ── INFO CARDS ── */}
        < section className="info-section" >
          <div className="sec-eye">Information</div>
          <div className="sec-title">Everything you need to know</div>
          <div className="info-grid">
            {infoCards.map((c, i) => (
              <div className="icard" key={i}>
                <div className="icard-icon" style={{ background: c.bg, color: c.color }}>{c.icon}</div>
                <div className="icard-title">{c.title}</div>
                <div className="icard-desc">{c.desc}</div>
              </div>
            ))}
          </div>
        </section >

        {/* ── PROCESS STEPS ── */}
        < section className="proc-section" >
          <div className="sec-eye" style={{ color: "#0369a1" }}>Process</div>
          <div className="sec-title">How migration works</div>
          <div className="steps">
            {steps.map((s, i) => (
              <div className="step" key={i}>
                <div className="step-num">{s.n}</div>
                {i < steps.length - 1 && <div className="step-line" />}
                <div className="step-t">{s.t}</div>
                <div className="step-d">{s.d}</div>
              </div>
            ))}
          </div>
        </section >

        {/* ── ABOUT + MAP ── */}
        < affl.Container fluid className="about-section" style={{ padding: "0 48px 44px" }
        }>
          <div className="sec-eye" style={{ color: "#0369a1", paddingTop: 36, marginBottom: 5 }}>About & location</div>
          <div className="sec-title">Contact us</div>
          <affl.Row className="g-4 about-row">
            <affl.Col xs={12} md={5} className="about-col">
              <div className="about-card">
                <h4>About Us</h4>
                <h5>Registered Address</h5>
                <p>
                  O/o Commissioner of Higher Education, A.P<br />
                  D.No. 11-307, Garudadri KK Towers,<br />
                  Lakshmi Narasimha Colony, NH-5 Service Road,<br />
                  Near Dr. NTR Vaidya Seva Trust,<br />
                  Mangalagiri, Guntur District – 522503
                </p>
                <div className="clink" style={{ marginTop: 14 }}>
                  <MdEmail size={14} /> cteapeh2018@gmail.com
                </div>


                <div style={{ marginTop: 24 }}>
                  <h5>Helpdesk Hours &emsp;

                    <MdPhone size={14} />  9247971035
                  </h5>
                  <p>
                    Monday – Friday: 10:00 AM – 5:00 PM<br />
                    {/* Saturday: 10:00 AM – 1:00 PM<br />
                    Sunday & public holidays: Closed */}
                  </p>
                  {/* <div className="clink" style={{ marginTop: 10 }}>
                    <MdPhone size={14} /> 1800-XXX-XXXX (toll free)
                  </div> */}
                </div>




              </div>
            </affl.Col>
            <affl.Col xs={12} md={7} className="map-col">
              <div className="map-wrap">
                <div className="map-hdr">
                  <div className="map-hdr-icon"><FaMapMarkerAlt /></div>
                  <span>Commissionerate of Higher Education, Mangalagiri</span>
                  <small>Guntur District, AP – 522503</small>
                </div>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d30617.370758078356!2d80.567148!3d16.416122!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35f71f131674d3%3A0x7ed661d1e16d9071!2sDEPARTMENT%20OF%20TECHNICAL%20EDUCATION!5e0!3m2!1sen!2sus!4v1779459443985!5m2!1sen!2sus"
                  width="100%"
                  style={{ border: 0, display: "block" }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="CHE Office Location"
                />
              </div>
            </affl.Col>
          </affl.Row>
        </affl.Container >

        <CommonFooter />



        {/* ── STUDENT MODAL ── */}
        <Modal show={activeModal === MODAL.STUDENT} onHide={closeModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>🎓 Student Login</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <LoginForm
              roleKey="student"
              accentColor="#f59e0b"
              textColor="#2d1a00"
              uidLabel="Student ID"
              uidPlaceholder="Enter Student ID"
              onSuccess={() => { closeModal(); navigate("/RusaDashboard"); }}
            />
          </Modal.Body>
        </Modal>

        {/* ── COLLEGE MODAL ── */}
        <Modal show={activeModal === MODAL.COLLEGE} onHide={closeModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>🏛️ College Login</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <LoginForm
              roleKey="college"
              accentColor="#0d9488"
              uidLabel="College Code"
              uidPlaceholder="Enter College Code"
              onSuccess={() => { closeModal(); }}
            />
          </Modal.Body>
        </Modal>

        {/* ── DEPARTMENT MODAL ── */}
        <Modal show={activeModal === MODAL.DEPT} onHide={closeModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>💼 Department Login</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <LoginForm
              roleKey="dept"
              accentColor="#1b6ca8"
              uidLabel="User ID"
              uidPlaceholder="Enter User ID"
              onSuccess={() => { closeModal(); }}
            />
          </Modal.Body>
        </Modal>

        <Modal show={showNotif} onHide={() => setShowNotif(false)} dialogClassName="notif-popup-modal">
          <Modal.Header closeButton>
            <Modal.Title> <img src="../images/new-icon.gif" alt="New"
              style={{ height: "35px", width: "35px", objectFit: "contain" }} /> Notifications</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="notif-popup-list">
              {notifications?.map((item) => (
                <div className="notif-popup-item" key={item.text}>
                  <span className="notif-dot" style={{ background: item.dot }} />
                  <div style={{ flex: 1 }}>
                    <div className="notif-text">{item.text}</div>
                  </div>
                  <div className="notif-popup-actions">
                    <button
                      type="button"
                      className="notif-popup-download"
                      onClick={() => downloadPdf(item.fileName)}
                      aria-label={`Download ${item.text}`}
                      title="Download"
                    >
                      <FaDownload className="notif-download-icon" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </Modal.Body>
        </Modal>

      </div >
    </>
  );
}